import { makeStyles } from '@mui/styles'
import { Theme, width } from '@mui/system'
import { FONTS, SPACES } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  settingsItemGroupWrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '20px',

    width: '100%',

    [theme.breakpoints.down('tablet')]: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '15px 0px',
      rowGap: '15px',
    },
    [theme.breakpoints.up('tablet')]: {
      padding: '25px 40px 40px',
      border: `1px solid ${theme.palette.custom.grey}`,
      borderRadius: 15,
    },
  },

  settingsItem: {
    width: '100%',
    maxWidth: '100%',

    [theme.breakpoints.down('tablet')]: {
      height: 'fit-content',
    },
  },

  itemTitle: {
    margin: 0,

    [theme.breakpoints.down('tablet')]: {
      fontWeight: FONTS.WEIGHTS.light,
      fontSize: '14px',
      lineHeight: 1.33,

      color: theme.palette.custom.grey2,
    },
    [theme.breakpoints.up('tablet')]: {
      fontWeight: FONTS.WEIGHTS.bold,
      fontSize: '18px',
      lineHeight: 1.4,

      color: theme.palette.custom.darkBlue2,
    },
  },

  itemGroupTitle: {
    margin: '0 auto',
    color: theme.palette.custom.darkBlue2,
    fontWeight: FONTS.WEIGHTS.bold,

    [theme.breakpoints.down('tablet')]: {
      fontSize: '14px',
      lineHeight: 1.33,

      // color: theme.palette.custom.grey2,
    },
    [theme.breakpoints.up('tablet')]: {
      fontSize: '18px',
      lineHeight: 1.4,
    },
  },

  itemGroupSubtitle: {
    margin: '0 auto',
    color: theme.palette.custom.grey2,
    fontWeight: FONTS.WEIGHTS.bold,

    [theme.breakpoints.down('tablet')]: {
      fontSize: '12px',
      lineHeight: 1.33,
    },
    [theme.breakpoints.up('tablet')]: {
      fontSize: '14px',
      lineHeight: 1.4,
    },
  },

  modalWrapper: {
    minHeight: 360,
    [theme.breakpoints.down('tablet')]: {
      minWidth: 320,
    },
    [theme.breakpoints.up('tablet')]: {
      minWidth: 400,
    },

    padding: SPACES.xxl,
  },
}))

export { useStyles }
